import React from 'react'

const Govermentlink = () => {
    // eslint-disable-next-line
    return (
        <div className="container bg-danger">
        <div className="progress-block-area">
        <h3 className="important-heading"><strong>Important Information <br /> For Corona - Virus</strong></h3>
        <div className="progress-block">
            <div className="progress-icon"><img src="https://www.mygov.in/sites/all/themes/mygov/images/covid/icon-one.png" alt="" /></div>
            <div className="progress-text-area">
                <h3><strong>+91-11-23978046 or 1075</strong></h3>
                <p>Dial National Helpline Number</p>
            </div>
        </div>
        
        <div className="progress-block">
            <div className="progress-icon"><img src="https://www.mygov.in/sites/all/themes/mygov/images/covid/icon-three.png" alt="" /></div>
            <div className="progress-text-area">
                <h3><strong>ncov2019[at]gov[dot]in</strong></h3>
                <p>Helpline Email ID </p>
            </div>
        </div>
    </div>
          </div>
    ) 
}

export default Govermentlink
